<template>
<div class="card">
    <div class="card-header d-flex align-items-center justify-content-between device-title">
        <h3>Configuration</h3> 
    </div>  
    <div class="card-body">
        <div class="d-flex" v-if="role === 'Supervisor'">
            <div class="form-group mr-2 flex-grow-1">               
                <b-form-select v-model="property.tenantId" name="tenantId" :options="tenantList" size="" v-validate="'required'"> </b-form-select>
                <div class="alert-danger" v-if="submitted && errors.has('tenantId')">{{errors.first('tenantId') }}</div>
            </div>
            <div class="form-group mr-2 flex-grow-1">
                <input class="form-control" placeholder="Property" name="name" v-model="property.name" v-validate="'required|min:1|max:32'">
                <div class="alert-danger" v-if="submitted && errors.has('name')">{{errors.first('name') }}</div>
            </div>
            <div class="form-group mr-2 flex-grow-1">
                <input class="form-control" placeholder="Value" name="value" v-model="property.value" v-validate="'required|min:1|max:16|numeric'">
                <div class="alert-danger" v-if="submitted && errors.has('value')">{{errors.first('value') }}</div>
            </div>
            <div class="form-group mr-2 flex-grow-1">
                <input class="form-control" placeholder="Unit" name="unit" v-model="property.unit" v-validate="'required|min:1|max:16'">
                <div class="alert-danger" v-if="submitted && errors.has('unit')">{{errors.first('unit')}}</div>
            </div>
            <div class="form-group mr-2 flex-grow-1">
                <input class="form-control" placeholder="Desc." name="description" v-model="property.description" v-validate="'min:1|max:16'">
                <div class="alert-danger" v-if="submitted && errors.has('description')">{{errors.first('newDescription')}}</div>
            </div>
            <div class="form-group mr-2 flex-grow-1">            
                <button type="button" class="btn btn-success mr-2 flex-grow-0" v-on:click="registerProperty()">New</button>
            </div>
        </div> <!--device control -->

        <table class="table table-striped table-bordered table-hover">
            <thead class="">
                <tr class="text-center device-table-header">
                    <th v-if="role === 'Supervisor'"></th>
                    <th v-if="role === 'Supervisor'">Tenant</th>
                    <th>Property</th>
                    <th>Value</th>
                    <th>Unit</th>
                    <th>Description</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="property in propertyList">
                    <td v-if="role === 'Supervisor'" class="text-center"><i style="font-size: 1.5em; color: DimGray;" class="fas fa-trash" type="button" @click="deleteProperty(property)"></i></td>
                    <td v-if="role === 'Supervisor'" class="text-center">{{ property.tenantId }}</td>
                    <td>{{ property.name }}</td>
                    <td>
                        <div class="input-group">
                            <input class="form-control" style="width:70px;" placeholder="Property Value" v-model="property.value">
                        </div>
                    </td>
                    <td>
                        <div class="input-group">
                            <input class="form-control" style="width:70px;" placeholder="" name="unit" v-model="property.unit">
                        </div>
                    </td>
                    <td>{{ property.description }}</td>
                    <td class="text-center">
                    <button type="button" class="btn btn-primary flex-grow-0" @click="updateProperty(property)">Save</button>
                    </td>
                </tr>
                <tr v-show="propertyList.length == 0">
                    <td class="text-center" colspan="4">결과가 없습니다.</td>
                </tr>
            </tbody>
        </table>
    </div> <!--card-body-->
<!--Message Modal-->
  <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
    <p class="my-4 text-center">{{ msgContent }}</p>
  </b-modal>   
</div> <!--card-->   

</template>

<script>
export default {
    name: 'Config',
    data() {
        return {
            property : {},
            submitted : false,
            loading: false, 
            msgStatus: '',
            msgContent: '',
            tenantList: [
            ]
        }
    },
    computed: {
        propertyList: function() {
            return this.$store.getters.getPropertyList;
        },
        role() {
            let user = JSON.parse(localStorage.getItem('user'));

            if (user && user.role) {
                return user.role;
            } else {
                return '';
            }
        }
    },
    methods: {
        showMessage(status, message) {
            this.msgStatus = status;
            this.msgContent = message;
            
            this.$bvModal.show('messageModal');
        },
        registerProperty() {
            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true;              

                    this.$store.dispatch('updateProperty', this.property)
                    .then(response => {
                        this.msgStatus = response.status;
                        this.msgContent = "Tenant(" + this.property.tenantId + ")의 " + this.property.name + " 설정값이 " + this.property.value + this.property.unit + "로 등록되었습니다.";
                        
                        this.$bvModal.show('messageModal');

                        this.property = {};
                    }).catch(response => {
                        this.msgStatus = response.status;
                        this.msgContent = response.message; 

                        this.$bvModal.show('messageModal');                        
                    }).finally(() => {
                        this.loading = false;
                        this.$store.dispatch('retrievePropertyList'); 

                        this.submitted = false;
                    });
                }
            });
        },
        updateProperty(property) {
            //유효성 검사
            if(property.name == null || property.name === '') {
                this.showMessage(-1, "Property Name은 필수 입력값입니다.");
                return;
            }

            const regExp = /^[0-9]+$/;
            if(!regExp.test(property.value)) {
                this.showMessage(-1, "Property Value는 숫자만 입력 가능합니다.");
                return;
            }

            if(property.unit == null || property.unit === '') {
                this.showMessage(-1, "Property Unit은 필수 입력값입니다.");
                return;
            }

            this.loading = true;

            this.$store.dispatch('updateProperty', property)
            .then(response => {
                this.msgStatus = response.status;
                this.msgContent = "Tenant(" + property.tenantId + ")의 " + property.name + " 설정값이 " + property.value + property.unit + "로 변경되었습니다.";
                
                this.$bvModal.show('messageModal');
            }).catch(response => {
                this.msgStatus = response.status;
                this.msgContent = response.message; 

                this.$bvModal.show('messageModal');                        
            }).finally(() => {
                this.loading = false;
                this.$store.dispatch('retrievePropertyList');
            });
        },
        deleteProperty(property) {
            this.$store.dispatch('deleteProperty', property);
        }, 
        hideModal() {
          this.$refs['messageModal'].hide();
        },
        retrieveTenantList() {
            var params = {};

            axios.get('user/retrieveTenantList', {
                    params: params,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': accessToken()
                    }
            }).then(response => {
                response.data.body.list.forEach((item, index, array) => {
                    this.tenantList.push({value: item.tenantId, text: "(" + item.tenantId + ") " + item.tenantName});
                });
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
            });
        }
    },
    created() {
    // var that = this;
        this.$store.dispatch('retrievePropertyList');
        this.retrieveTenantList();
        
    // .then(() => {
    // });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
